// SALT2の3つの事業（Home / About / 各事業ページで共用する正本）
// 出典: 営業_会社とサービスのご紹介 v0.1（2026年10月）「WHAT WE DO」。
// 「3つの事業は、企業の課題を起点につながっています」のような主張は載せない（2026-10-17 代表指示）。
// img は各事業ページの配色（Trooper・コンサル=オレンジ、内製化支援=ブルー）に合わせた建築写真。
export const businesses = [
  {
    id: 'trooper',
    num: '01',
    en: 'PRODUCT',
    name: 'Trooper',
    kind: 'AIエージェント製品',
    headline: '企業の仕事を、AIエージェントに任せる',
    desc: '共通の基盤の上で、仕事ごとのエージェントと業務アプリを育てる。メールの受信や決めた時刻をきっかけに、調べ、作り、記録するところまで進め、判断が要ることだけを人に上げます。',
    role: 'エージェントに任せる仕事',
    roleDesc: 'エージェントが、一員として働く。繰り返す仕事を、任せ続けられる。',
    path: '/trooper', // 製品LP（public/trooper/）へ。App.js の StaticPage で読み込み直す
    lp: '/trooper/', // LP は新しいタブで開く（2026-10-17 代表指示）。静的ページを直接開く
    img: '/img/architecture/orange/p06-orange-entry-threshold.jpg',
  },
  {
    id: 'enablement',
    num: '02',
    en: 'ENABLEMENT',
    name: '内製化支援',
    kind: 'AI内製化支援',
    headline: '企業が、自らAIで仕事を変えられるように',
    desc: 'AIを使い、つくり、発注と評価を主導する力を、法人向けの研修と育成のプログラムで育てる。ワークショップ、FDEチーム、内製化支援プログラムの3つの形で支援します。',
    role: '社内の人が担う仕事',
    roleDesc: '社内の人が、自分でできるようにする。AI駆動開発から、いま使っているAI基盤の活用まで。',
    path: '/enablement',
    lp: '/enablement',
    img: '/img/architecture/blue/p04-blue-inset-ramp.jpg',
  },
  {
    id: 'consulting',
    num: '03',
    en: 'CONSULTING',
    name: 'AIコンサルティング・開発',
    kind: 'AIコンサルティング・開発',
    headline: '課題の特定から、実装・定着まで',
    desc: 'Boostと一緒に企業の課題に入り、AIを使われ続ける形にする。FDEチームが現場に入り、伺ったその場で作ります。',
    role: 'どこに、どうAIを入れるか',
    roleDesc: 'SALT2が現場に入り、個別に解く。チームで現場に入り、実装と定着まで進める。',
    path: '/cases',
    lp: '/cases',
    img: '/img/architecture/orange/p09-orange-ramp-strip.jpg',
  },
];
